export const GET_CREDIT_SCORES = 'GET_CREDIT_SCORES';
export const GET_CREDIT_SCORES_FAIL = 'GET_CREDIT_SCORES_FAIL';
export const GET_CREDIT_SCORES_SUCCESS = 'GET_CREDIT_SCORES_SUCCESS';
